// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"78257ef0","292":"fcc3cdce","551":"f08f88f6","617":"5928ad02","828":"89358f49","842":"8df647c5"}[chunkId] + ".chunk.js";
};